import { Modal } from "artisn-ui-react";
import styled from "styled-components";

import { CorporateInfoModalStyledProps as Props } from "./CorporateInfoModal.types";

const CorporateInfoModalStyled = styled(Modal)<Props>`
  .CorporateInfoModal {
    &__content {
      background-color: var(--palette-dark-blue-s13-l11);
      border-radius: 1.6rem;
      padding: 2.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 5.2rem;
    }

    &__title {
      font-size: 2.4rem;
      line-height: 2.4rem;
      font-weight: 600;
      text-align: center;
      color: var(--palette-white);
      max-width: 32rem;
      padding-top: 2.4rem;
    }

    &__step-wrapper {
      padding-top: 1.2rem;
      color: var(--palette-white);
      font-size: 1.6rem;
      padding-left: 1.6rem;
      max-width: 62rem;
    }

    &__btn {
      color: black;
      width: 24rem;
      font-size: 1.6rem;
      font-weight: 700;
      margin-top: 2.4rem;
    }
  }
`;

export default CorporateInfoModalStyled;
